module.exports = __webpack_public_path__ + "img/ovation-of-the-seas.959d4c30.jpg";